/* ==========================================================================
   CONTREPIED — comportements légers (aucune librairie)
   - apparition des éléments au scroll (IntersectionObserver)
   - en-tête qui se compacte au scroll
   - menu mobile
   - ajout au panier sans rechargement + compteur du panier
   - barre d'achat collante sur mobile (page produit)
   ========================================================================== */
(() => {
  const root = document.documentElement;
  root.classList.add('cp-js');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Apparition au scroll ---------- */
  const initReveal = (scope = document) => {
    const items = scope.querySelectorAll('[data-cp-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach((el) => io.observe(el));
  };

  /* ---------- En-tête : compact au scroll ---------- */
  const initHeader = () => {
    const header = document.querySelector('[data-cp-header]');
    if (!header) return;
    // Sur ordinateur, Horizon fait défiler .page-wrapper et non la fenêtre : on écoute les deux.
    const wrapper = document.querySelector('.page-wrapper');
    const scrollTop = () => Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
    let ticking = false;
    const update = () => {
      header.classList.toggle('is-compact', scrollTop() > 24);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    wrapper?.addEventListener('scroll', onScroll, { passive: true });
    update();

    /* Menu mobile */
    const toggle = header.querySelector('[data-cp-menu-toggle]');
    const panel = document.getElementById(toggle?.getAttribute('aria-controls') || '');
    if (!toggle || !panel) return;

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
      panel.hidden = !open;
      document.body.classList.toggle('cp-menu-open', open);
      if (open) panel.querySelector('a')?.focus();
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    panel.addEventListener('click', (e) => {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });
    window.matchMedia('(min-width: 900px)').addEventListener('change', (e) => {
      if (e.matches) setOpen(false);
    });
  };

  /* ---------- Barre d'achat collante (mobile) ---------- */
  const initStickyBuy = () => {
    const bar = document.querySelector('[data-cp-sticky-buy]');
    const target = document.querySelector('[data-cp-buy-anchor]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', String(!passed));
      bar.querySelectorAll('a, button').forEach((el) => (el.tabIndex = passed ? 0 : -1));
    });
    io.observe(target);
  };

  /* ---------- Bandeaux défilants : pause si mouvement réduit ---------- */
  const initMarquees = () => {
    document.querySelectorAll('.cp-marquee').forEach((m) => m.classList.toggle('is-paused', reducedMotion.matches));
  };

  const init = () => {
    initReveal();
    initHeader();
    initStickyBuy();
    initMarquees();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Éditeur de thème : réinitialiser quand une section est rechargée */
  document.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target);
    if (e.target.querySelector('[data-cp-header]')) initHeader();
    initStickyBuy();
    initMarquees();
  });
})();
